/**
 * Phase-1 BD/CM API 사용 여부.
 * - 기본: ON (REACT_APP_USE_BD_API 미설정 시)
 * - 로컬 localStorage PoC로 되돌릴 때: REACT_APP_USE_BD_API=false
 */
export function isBdApiEnabled() {
  const v = process.env.REACT_APP_USE_BD_API;
  if (v === '0' || v === 'false' || v === 'FALSE') return false;
  return true;
}
